export function redirectHard(url) {
    window.location.href = url;
}
